/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ReactNode } from 'react';

import { css, jsx } from '@compiled/react';
import { useIntl } from 'react-intl';

import Heading from '@atlaskit/heading';
import { Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from '../../common/messages';

type ManagedBlockConfigFrameProps = {
	children: ReactNode;
	testId: string;
};

const wrapperStyles = css({
	width: '100%',
	boxSizing: 'border-box',
	backgroundColor: token('elevation.surface'),
	borderColor: token('color.border'),
	borderStyle: 'solid',
	borderWidth: token('border.width'),
	borderRadius: token('radius.small'),
	paddingTop: token('space.200'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.150'),
	paddingLeft: token('space.200'),
	boxShadow: token('elevation.shadow.overlay'),
});

export const ManagedBlockConfigFrame = ({
	children,
	testId,
}: ManagedBlockConfigFrameProps): JSX.Element => {
	const intl = useIntl();

	return (
		<div css={wrapperStyles} data-testid={testId}>
			<Stack space="space.150">
				<Heading size="small">{intl.formatMessage(messages.configureBlock)}</Heading>
				{children}
			</Stack>
		</div>
	);
};
